module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_basque-country-9fa5037f394567ba4c7c5df386fe0178.png";